import { Pipe, PipeTransform } from '@angular/core';
import { ContactMethod } from 'src/app/models/contact';

@Pipe({
    name: 'contactMethodList',
    standalone: true
})
export class ContactMethodListPipe implements PipeTransform {
  transform(value: ContactMethod[], ...args: unknown[]): string {
    return value.map((method) => method.value).join(' | ');
  }
}
